import { OrderFailReason } from "../../../models/order";
import { FailDetailGroup, FailDetailOther, OrderFailDetailsReport } from "../../../models/orderAnalytics";
import { formatInt, toNum } from "../../bids/analytics/format";
import { ordersListUrl, signatureSearchText } from "./drilldown";
import { failedStatusFor } from "./failReasons";

/** «26 · Revoked»; неизвестный код — только число; без кода — прочерк */
export function steamCodeLabel(code: number | null | undefined, name: string | null | undefined): string {
    if (code === null || code === undefined) {
        return "—";
    }
    return name ? `${code} · ${name}` : String(code);
}

/**
 * Ссылка из текста ошибки в список ордеров: причина (если есть), слова сигнатуры без плейсхолдеров, игра и период.
 * Если слов не осталось (текст из одних плейсхолдеров или без комментария) — ссылки нет.
 */
export function signatureListUrl(group: FailDetailGroup, ctx: { gameId?: number; from: Date; to: Date }): string | null {
    const comment = signatureSearchText(group.signature);
    if (!comment) {
        return null;
    }
    return ordersListUrl({
        status: failedStatusFor(group.failReason),
        failReason: group.failReason ?? null,
        comment,
        gameId: ctx.gameId,
        from: ctx.from,
        to: ctx.to,
    });
}

export function orderUrl(orderId: number): string {
    return `/app/orders/${orderId}`;
}

/** Тексты одной причины из общего отчёта — для «Без причины», которую нельзя запросить фильтром */
export function groupsForReason(report: OrderFailDetailsReport, reason: OrderFailReason | null): FailDetailGroup[] {
    return report.groups.filter((g) => (g.failReason ?? null) === reason);
}

/** Подпись текстов за пределами топа; null, если их нет */
export function otherGroupsLabel(other: FailDetailOther): string | null {
    return toNum(other.groupsCount) > 0
        ? `и ещё ${formatInt(other.groupsCount)} текстов, ${formatInt(other.count)} позиций`
        : null;
}
